import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "form"
}
const _hoisted_2 = { class: "w-100 d-flex gap-4 flex-md-row flex-column" }
const _hoisted_3 = { class: "w-100 d-flex gap-4 flex-md-row flex-column" }
const _hoisted_4 = { class: "w-100 d-flex gap-4 flex-md-row flex-column" }
const _hoisted_5 = { class: "w-100 d-flex gap-4 flex-md-row flex-column" }
const _hoisted_6 = {
  key: 0,
  class: "form w-100"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h4", { class: "w-100" }, "Address", -1)
const _hoisted_8 = {
  key: 1,
  class: "form"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_DateInput = _resolveComponent("DateInput")!

  return (_ctx.dependent && _ctx.person)
    ? (_openBlock(), _createElementBlock("form", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_TextInput, {
            type: "text",
            label: "Relationship",
            modelValue: _ctx.dependent.Relationship,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dependent.Relationship) = $event)),
            required: true,
            "has-changes": _ctx.changes?.Relationship,
            readonly: true
          }, null, 8, ["modelValue", "has-changes"]),
          _createVNode(_component_TextInput, {
            type: "text",
            label: "Country",
            modelValue: _ctx.person.CitizenshipCode,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.person.CitizenshipCode) = $event)),
            required: true,
            "has-changes": _ctx.changes?.CitizenshipCode,
            readonly: true
          }, null, 8, ["modelValue", "has-changes"]),
          _createVNode(_component_TextInput, {
            type: "text",
            name: "number",
            label: "Social Security",
            placeholder: "Enter SSN here",
            modelValue: _ctx.person.SSN,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.person.SSN) = $event)),
            required: true,
            "has-changes": _ctx.changes.SSN,
            readonly: true
          }, null, 8, ["modelValue", "has-changes"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_TextInput, {
            type: "text",
            label: "Salutation",
            placeholder: "Salutation",
            max: 12,
            modelValue: _ctx.person.Salutation,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.person.Salutation) = $event)),
            readonly: true,
            required: true,
            "has-changes": _ctx.changes.Salutation
          }, null, 8, ["modelValue", "has-changes"]),
          _createVNode(_component_TextInput, {
            type: "text",
            label: "First Name",
            placeholder: "Enter First Name",
            max: 12,
            modelValue: _ctx.person.FirstName,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.person.FirstName) = $event)),
            readonly: true,
            required: true,
            "has-changes": _ctx.changes.FirstName
          }, null, 8, ["modelValue", "has-changes"]),
          _createVNode(_component_TextInput, {
            type: "text",
            label: "Middle Name",
            placeholder: "Enter Middle Name",
            max: 12,
            modelValue: _ctx.person.MiddleName,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.person.MiddleName) = $event)),
            readonly: true,
            "has-changes": _ctx.changes.MiddleName
          }, null, 8, ["modelValue", "has-changes"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_TextInput, {
            type: "text",
            label: "Last Name",
            placeholder: "Enter Last Name",
            max: 25,
            modelValue: _ctx.person.LastName,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.person.LastName) = $event)),
            readonly: true,
            "has-changes": _ctx.changes.LastName
          }, null, 8, ["modelValue", "has-changes"]),
          _createVNode(_component_TextInput, {
            type: "text",
            label: "Suffix",
            placeholder: "Suffix",
            modelValue: _ctx.person.NameSuffix,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.person.NameSuffix) = $event)),
            readonly: true,
            required: true,
            "has-changes": _ctx.changes.NameSuffix
          }, null, 8, ["modelValue", "has-changes"]),
          _createVNode(_component_DateInput, {
            label: "Date of Birth",
            modelValue: _ctx.person.DateofBirth,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.person.DateofBirth) = $event)),
            placeholder: 'dd/mm/yyyy',
            "input-type": "date",
            readonly: true,
            "has-changes": _ctx.changes.DateofBirth
          }, null, 8, ["modelValue", "has-changes"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_TextInput, {
            type: "text",
            label: "Gender",
            modelValue: _ctx.person.Sex,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.person.Sex) = $event)),
            readonly: true,
            "has-changes": _ctx.changes.Sex
          }, null, 8, ["modelValue", "has-changes"]),
          (_ctx.person.MaritalStatus)
            ? (_openBlock(), _createBlock(_component_TextInput, {
                key: 0,
                type: "text",
                label: "Marital Status",
                placeholder: "Marital Status",
                modelValue: _ctx.person.MaritalStatus,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.person.MaritalStatus) = $event)),
                readonly: true,
                required: true,
                "has-changes": _ctx.changes.MaritalStatus
              }, null, 8, ["modelValue", "has-changes"]))
            : _createCommentVNode("", true),
          (_ctx.dependent.MarriageDate)
            ? (_openBlock(), _createBlock(_component_DateInput, {
                key: 1,
                label: "Marriage/Affidavit Date",
                modelValue: _ctx.dependent.MarriageDate,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.dependent.MarriageDate) = $event)),
                placeholder: 'dd/mm/yyyy',
                "input-type": "date",
                readonly: true,
                "has-changes": _ctx.changes.MarriageDate
              }, null, 8, ["modelValue", "has-changes"]))
            : _createCommentVNode("", true),
          (_ctx.dependent.DivorceDate)
            ? (_openBlock(), _createBlock(_component_DateInput, {
                key: 2,
                label: "Divorce/Affidavit Date",
                modelValue: _ctx.dependent.DivorceDate,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.dependent.DivorceDate) = $event)),
                placeholder: 'dd/mm/yyyy',
                "input-type": "date",
                readonly: true,
                "has-changes": _ctx.changes.DivorceDate
              }, null, 8, ["modelValue", "has-changes"]))
            : _createCommentVNode("", true),
          (_ctx.person.DateofDeath)
            ? (_openBlock(), _createBlock(_component_DateInput, {
                key: 3,
                label: "Date of Death/Affidavit Date",
                modelValue: _ctx.person.DateofDeath,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.person.DateofDeath) = $event)),
                placeholder: 'dd/mm/yyyy',
                "input-type": "date",
                readonly: true,
                "has-changes": _ctx.changes.DateofDeath
              }, null, 8, ["modelValue", "has-changes"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_TextInput, {
          type: "tel",
          name: "phone",
          label: "Telephone Number",
          placeholder: "Enter Phone Number here",
          max: 50,
          modelValue: _ctx.contact.Phone,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.contact.Phone) = $event)),
          required: true,
          "has-changes": _ctx.changes.Phone,
          readonly: true
        }, null, 8, ["modelValue", "has-changes"]),
        _createVNode(_component_TextInput, {
          type: "email",
          label: "Email Address",
          placeholder: "Enter Email here",
          max: 50,
          modelValue: _ctx.contact.Email,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.contact.Email) = $event)),
          required: true,
          "has-changes": _ctx.changes.Email,
          readonly: true
        }, null, 8, ["modelValue", "has-changes"]),
        (_ctx.contact.Address)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_TextInput, {
                type: "text",
                label: "Address Type",
                placeholder: "Enter Address Type",
                max: 25,
                modelValue: _ctx.contact.Address.Type,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.contact.Address.Type) = $event)),
                required: true,
                "has-changes": _ctx.changes.Address?.Type,
                readonly: true
              }, null, 8, ["modelValue", "has-changes"]),
              _createVNode(_component_TextInput, {
                type: "text",
                label: "Address",
                placeholder: "Enter Address 1",
                max: 30,
                readonly: true,
                modelValue: _ctx.contact.Address.Street1,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.contact.Address.Street1) = $event)),
                required: true,
                "has-changes": _ctx.changes.Address?.Street1
              }, null, 8, ["modelValue", "has-changes"]),
              _createVNode(_component_TextInput, {
                type: "text",
                label: "City",
                placeholder: "Enter City",
                max: 25,
                modelValue: _ctx.contact.Address.City,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.contact.Address.City) = $event)),
                required: true,
                "has-changes": _ctx.changes.Address?.City,
                readonly: true
              }, null, 8, ["modelValue", "has-changes"]),
              _createVNode(_component_TextInput, {
                type: "text",
                label: "State",
                placeholder: "Enter State",
                max: 25,
                modelValue: _ctx.contact.Address.State,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.contact.Address.State) = $event)),
                required: true,
                "has-changes": _ctx.changes.Address?.State,
                readonly: true
              }, null, 8, ["modelValue", "has-changes"]),
              _createVNode(_component_TextInput, {
                type: "text",
                label: "Country",
                placeholder: "Enter Country",
                max: 25,
                modelValue: _ctx.contact.Address.Country,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.contact.Address.Country) = $event)),
                required: true,
                "has-changes": _ctx.changes.Address?.Country,
                readonly: true
              }, null, 8, ["modelValue", "has-changes"]),
              _createVNode(_component_TextInput, {
                type: "text",
                name: "number",
                label: "Postal Code",
                placeholder: "Enter Postal Code",
                max: 9,
                "has-changes": _ctx.changes.Address?.Zip,
                modelValue: _ctx.contact.Address.Zip,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.contact.Address.Zip) = $event)),
                required: true,
                readonly: true
              }, null, 8, ["has-changes", "modelValue"])
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_8, " Data is not available "))
}